import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import { validateChangePasswordForm } from '../../utils/validators/validateForm';
import { NotificationManager } from 'react-notifications';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import HOCSectionLoader from '../../components/HOC/HOCSectionLoader.jsx';
import { FormattedMessage, injectIntl } from 'react-intl';

class ChangePassword extends React.Component {
    constructor(props) {
        super();
        this.state = {
            error: '',
            passwordError: '',
            newPasswordError: '',
            confirmPasswordError: '',
            password: '',
            newPassword: '',
            confirmPassword: '',
            loader: false,
            loaderButton: false,
            noResponse: false,
            errorMessage: ''
        };
    }

    submit = params => {
        const { password, newPassword, confirmPassword } = this.state;
        if (
            validateChangePasswordForm(
                { password, newPassword, confirmPassword },
                this.handleError
            )
        ) {
            this.setState({ loaderButton: true });
            this.props.changePasswordAction(
                {
                    password,
                    newPassword,
                    confirmPassword
                },
                this.onDone
            );
        } else {
            NotificationManager.error(
                <FormattedMessage
                    id="Validation Error"
                    defaultMessage="Validation Error"
                />,
                'Oops!'
            );
        }
    };
    handleError = params => {
        this.setState(params);
    };

    onDone = (success, data) => {
        if (success) {
            this.setState({ loaderButton: false });
            NotificationManager.success(
                <FormattedMessage
                    id="passwordChangedSuccess"
                    defaultMessage="Password Changed Successfully"
                />,
                'Success'
            );
            this.props.history.push(`/user/profile`);
        } else {
            this.setState({ loaderButton: false });
            NotificationManager.error(data, 'Error');
        }
    };
    renderButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        }
        return (
            <Button
                variant="raised"
                color="primary"
                className="jr-btn"
                onClick={this.submit}
            >
                <FormattedMessage
                    id="changePassword"
                    defaultMessage="Change Password"
                />
            </Button>
        );
    };

    render() {
        const { match } = this.props;
        const {
            error,
            passwordError,
            newPasswordError,
            confirmPasswordError,
            loaderButton
        } = this.state;
        const { formatMessage } = this.props.intl;
        return (
            <HOCSectionLoader
                loading={this.state.loader}
                noResponse={this.state.noResponse}
                redirect={this.state.redirect}
                errorShow={error}
            >
                <div className="tz-2-com tz-2-main">
                    <h4>
                        <FormattedMessage
                            id="changePassword"
                            defaultMessage="Change Password"
                        />
                    </h4>
                    <div className="db-list-com ">
                        <div className="hom-cre-acc-left hom-cre-acc-right mt-3">
                            <form
                                className="form-new"
                                noValidate
                                autoComplete="off"
                                id="customer-create"
                            >
                                <div className=" mt-0 mb-0">
                                    <TextField
                                        error={passwordError ? true : false}
                                        helperText={passwordError}
                                        className="login-form-textfield"
                                        type="password"
                                        name="password"
                                        id="password"
                                        fullWidth
                                        label={formatMessage({
                                            id: 'addOldPassword'
                                        })}
                                        margin="normal"
                                        onChange={event => {
                                            this.setState({
                                                password: event.target.value,
                                                passwordError: '',
                                                error: ''
                                            });
                                        }}
                                        disabled={loaderButton ? true : false}
                                    />
                                </div>
                                <div className="mt-0 mb-0">
                                    <TextField
                                        error={newPasswordError ? true : false}
                                        helperText={newPasswordError}
                                        className="login-form-textfield"
                                        type="password"
                                        name="newPassword"
                                        id="newPassword"
                                        fullWidth
                                        label={formatMessage({
                                            id: 'addNewPassword'
                                        })}
                                        onChange={event => {
                                            this.setState({
                                                newPassword: event.target.value,
                                                newPasswordError: '',
                                                error: ''
                                            });
                                        }}
                                        margin="normal"
                                        disabled={loaderButton ? true : false}
                                    />
                                </div>
                                <div className="mt-0 mb-0">
                                    <TextField
                                        error={
                                            confirmPasswordError ? true : false
                                        }
                                        helperText={confirmPasswordError}
                                        className="login-form-textfield"
                                        type="password"
                                        name="confirmPassword"
                                        placeholder="confirmPassword"
                                        id="confirmPassword"
                                        fullWidth
                                        label={formatMessage({
                                            id: 'addconfirmPassword'
                                        })}
                                        onChange={event => {
                                            this.setState({
                                                confirmPassword:
                                                    event.target.value,
                                                confirmPasswordError: '',
                                                error: ''
                                            });
                                        }}
                                        margin="normal"
                                        disabled={loaderButton ? true : false}
                                    />
                                </div>
                                <div className="">
                                    <div className="mt-3 mb-4 log-btn">
                                        {this.renderButton()}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </HOCSectionLoader>
        );
    }
}

export default connect(
    null,
    actions
)(injectIntl(ChangePassword));



// WEBPACK FOOTER //
// ./src/views/User/ChangePassword.jsx